import { makeStyles } from "@fluentui/react-components";
import { customTokens } from "../../../theme/theme";

export const useStyles = makeStyles({
  container: {
    backgroundColor: customTokens.colorNeutralBackground1,
  },

  dropdownContainer: {
    display: "grid",
    gap: "16px",
    gridTemplateColumns: "auto auto auto",
    alignItems: "center",

    "@media (max-width: 768px)": {
      gridTemplateColumns: "auto",
    },
  },

  buttonContainer: {
    display: "flex",
    gap: "8px",
  },
});
